import '../../../../src/assets/fonts/GenSenRounded-R.ttc'
export const SVGformat={
    startTag:'<svg height="842" width="595" version="1.1" xmlns="http://www.w3.org/2000/svg">',
    SVGstyle:`<defs>
        <style type="text/css">
                text.text {
                    font-family: GSRR;
                    src: url('../../../../src/assets/fonts/GenSenRounded-R.ttc');
                    letter-spacing:2px;
                }
                text.title{ font-size: 16px; }
                text.content{ 
                    font-size: 12px; 
                    letter-spacing: 1px;
                }
                text.watermark{ font: 8px monospace; }
                tspan.redNotice{ 
                    fill: red; 
                    font-weight: bold;
                    letter-spacing: 0px;
                }
                text.displayNone{ display:none; }
        </style>
    </defs>`,
    backGround:'<rect width="100%" height="100%" fill="white"/>',
    header:function(props, day, printTime, company_img){return `
        <text x="3%" y="2.5%" class='watermark' >MWG Technology Co., Ltd.</text>
        <text x="65%" y="2.5%" class='watermark' >print time : ${printTime}</text>
        <text x="3%" y="6%" class='text title' >智慧照護每日報表</text>
        <text x="3%" y="9.5%" class='text title'>${props.first_name} ${props.last_name}</text>
        <text x="3%" y="13%" class='text content'>${day} </text>
    `},
    alert:function(title, alertARR){
        return`
            <text x="3%" y ="20%" class='text title'>${title}</text>
            <text x="3%" y ="23.5%" class='text content'>${alertARR[0][0]}</text>
            <text x="20%" y ="23.5%" class='text content'>${alertARR[0][1]}</text>
            <text x="50%" y ="23.5%" class='text content'>${alertARR[1][0]}</text>
            <text x="68%" y ="23.5%" class='text content'>${alertARR[1][1]}</text>
            <text x="3%" y ="26%" class='text content'>${alertARR[2][0]}</text>
            <text x="20%" y ="26%" class='text content'>${alertARR[2][1]}</text>
            <text x="50%" y ="26%" class='text content'>${alertARR[3][0]}</text>
            <text x="68%" y ="26%" class='text content'>${alertARR[3][1]}</text>
            <text x="3%" y ="28.5%" class='text content'>${alertARR[4][0]}</text>
            <text x="20%" y ="28.5%" class='text content'>${alertARR[4][1]}</text>
        `
    },
    sleep:function(title, sleepTitle, sleepArr){
        if(sleepArr===undefined){ return `
            <text x="3%" y ="35%" class='text title'>${title}</text>
            <text x="3%" y ="38.5%" class='text content'>當日無睡眠記錄</text>
        `}
        return `
            <text x="3%" y ="35%" class='text title'>${title}</text>
            
            <text x="3%" y ="38.5%" class='text content'>${sleepTitle[0]}</text>
            <text x="20%" y ="38.5%" class='text content'>${(sleepArr.SE!=="None")?parseFloat(sleepArr.SE).toFixed(2):"-"}</text>

            <text x="50%" y ="38.5%" class='text content'>${sleepTitle[1]}</text>
            <text x="68%" y ="38.5%" class='text content'>${calculateAlert(sleepArr.total_time, sleepArr.average_total_time, translate_Sec_to_Hr, 68)}</text>

            <text x="3%" y ="41%" class='text content'>${sleepTitle[2]}</text>
            <text x="20%" y ="41%" class='text content'>${calculateAlert(sleepArr.total_sleep_time, sleepArr.average_total_sleep_time, translate_Sec_to_Hr, 22)}</text>

            <text x="50%" y ="41%" class='text content'>${sleepTitle[3]}</text>
            <text x="68%" y ="41%" class='text content'>${calculateAlert(sleepArr.total_sleep_latency, sleepArr.average_total_sleep_latency, translate_Sec_to_Hr, 68)}</text>
            
            <text x="3%" y ="43.5%" class='text content'>${sleepTitle[4]}</text>
            <text x="20%" y ="43.5%" class='text content'>${(sleepArr.turn_over_num!=="None")? calculateAlert(sleepArr.turn_over_num, sleepArr.average_turn_over_num, a=>a, 22):"-"}</text>

            <text x="50%" y ="43.5%" class='text content'>${sleepTitle[5]}</text>
            <text x="68%" y ="43.5%" class='text content'>${(sleepArr.NIB_num!=="None")? calculateAlert(sleepArr.NIB_num, sleepArr.average_NIB_num, a=>a, 68):"-"}</text>

            <text x="3%" y ="46%" class='text content'>${sleepTitle[6]}</text>
            <text x="20%" y ="46%" class='text content'>${calculateAlert(sleepArr.total_NIB_time, sleepArr.average_total_NIB_time, translate_Sec_to_Hr, 22)}</text>

            <text x="50%" y ="46%" class='text content'>${sleepTitle[7]}</text>
            <text x="68%" y ="46%" class='text content'>${calculateAlert(sleepArr.NIB_max_time, sleepArr.average_NIB_max_time, translate_Sec_to_Hr, 68)}</text>
        `
    },
    breath:function(title, chart){
        return `
        <text x="3%" y ="51.5%" class='text title'>${title}</text>
        ${chart}
        `
    }, 
    endTag:'</svg>'

}

function translate_Sec_to_Hr(sec){
    let _sec = parseInt(sec)
    let _hours = parseInt(_sec/3600)%60
    let _min = parseInt(_sec/60)%60
    // return (sec!=="None")? `${_hours}${t("GLOBAL.UNIT.HOURS")}${_min}${t("GLOBAL.UNIT.MINUTE")}`:"-"
    return (sec!=="None")? `${_hours} hrs. ${_min} min.`:"-"
}

function calculateAlert(_rec, _avg, _func, x){
    let _percentage = Math.round(100*(parseInt(_rec)-parseInt(_avg))/parseInt(_avg))
    if(_percentage>10){return `
            <tspan class='redNotice'>${_func(_rec)}</tspan>
            <tspan x='${x+17}%' class='redNotice'>(>${_percentage}%)</tspan>
        `}
    else if(_percentage<-10){return `
            <tspan class='redNotice'>${_func(_rec)}</tspan>
            <tspan x='${x+17}%' class='redNotice'>(<${_percentage}%)</tspan>
        `}
    else{ return _func(_rec) }
}
